import React from 'react';
import moment from 'moment';
import ButtonTableAction from "../../../../../../components/buttons/ButtonTableAction";
import {EventProgram, EventProgramFilters} from "../../../../../../app/models/EventProgram";
import {momentParseDate} from "../../../../../../helpers";
import DefaultDataTable from "../../../../../../components/default/DefaultDataTable";
// import ChangeStatusEventProgram from '../EventProgramChangeStatus';

interface Props {
    eventPrograms: EventProgram[];
    callbackSuccess?: () => void;
    totalRows: number;
    loading?: boolean;
    edit?: (id: number) => void;
    destroy?: (id: number) => void;
    filter: EventProgramFilters;
    setFilter: (filter: EventProgramFilters) => void;
    show: (id: number) => void;

}

const EventProgramDataTable = ({
    eventPrograms,
    totalRows,
    callbackSuccess,
    loading = false,
    edit,
    show,
    destroy,
    filter,
    setFilter,
}: Props) => {


    const columns = [
        {
            name: 'Id',
            selector: (row: EventProgram) => row?.id,
            sortable: true,
            sortField: 'id',
        },
        {
            name: 'Motivo',
            selector: (row: EventProgram) => row?.title,
            sortable: true,
            sortField: 'reason',
        },
        {
            name: 'Fecha',
            selector: (row: EventProgram) => momentParseDate(row?.start_date),
            sortable: true,
            sortField: 'start_date',
        },

        {
            name: 'Hora Inicio',
            selector: (row: EventProgram) => moment(row?.start_hour, 'HH:mm:ss').format('HH:mm'),
            sortable: true,
            sortField: 'start_hour',
        },
        {
            name: 'Hora Fin',
            selector: (row: EventProgram) => moment(row?.end_hour, 'HH:mm:ss').format('HH:mm'),
            sortable: true,
            sortField: 'end_hour',
        },
        {
            name: 'Acciones',
            selector: (row: EventProgram) => row?.id,
            cell: (row: EventProgram) => (
                <div>
                    {show && (
                        <ButtonTableAction
                            callbackFunction={() => show(row?.id ?? -1)}
                            classIcon={'mdi mdi-eye'}
                            colorIcon={'text-info'}
                            errorMessage={'No se puede mostrar este registro.'}
                            title={'Ver'}
                        />
                    )}
                    {edit && (
                        <ButtonTableAction
                            callbackFunction={() => edit(row.id ?? 0)}
                            classIcon={'mdi mdi-pencil'}
                            colorIcon={'text-warning'}
                            title={'Editar'}
                        />
                    )}
                    {destroy && (
                        <ButtonTableAction
                            callbackFunction={() => destroy(row.id ?? 0)}
                            classIcon={'mdi mdi-delete'}
                            colorIcon={'text-danger'}
                            title={'Eliminar'}
                        />
                    )}
                </div>
            ),
        },
    ];

    return (
        <DefaultDataTable
            columns={columns}
            data={eventPrograms}
            progressPending={loading}
            paginationTotalRows={totalRows}
            filter={filter}
            setFilter={setFilter}
        />
    );
};

export default EventProgramDataTable;
